import APIClient from '@/shared/http/clients/api'

const resourceName = 'subcategoria-fila'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (config = {}) => APIClient.get(`${APICore}/${resourceName}/`, config)
const Search = (date = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?data=${date}&page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data, id) => APIClient.put(`${APICore}/${resourceName}/${id}`, data)
const Inactivate = (id, data, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/inactivate`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const SubCategoriaRepository = {
  GetAllPaging,
  Search,
  GetById,
  Create,
  Update,
  Inactivate,
  Delete
}

export default SubCategoriaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/nxSenhas/subCategoria.js